import { SearchOutlined } from "@ant-design/icons";
import { GenericCardList } from "@seims/shared";
import { Button, Col, Input, Row } from 'antd';
import PropTypes from 'prop-types';
import { useState } from "react";

export const GenericSearchableList = ({ 
  dataSource, 
  renderItem, 
  pageSize = 6,
  onHandleSearch = null,
  searchHint="Search for items",
  isLoading=false,
  pagination = {}
}) => {

  const [searchText, setSearchText] = useState("");

  const handleSearch = (text) => {
    console.log("TEXT 2", text);
    
    setSearchText(text);
    if (onHandleSearch) {
      onHandleSearch(text);
    }
  };

  return (
  <>
    <Row 
      gutter={[8, 16]}
      style={{ marginBottom: 16, alignItems: 'center' }}
    >
      <Col xs={24} sm={{ flex: 'auto' }}>
        <Input
        prefix={<SearchOutlined />} 
          placeholder={searchHint}
          value={searchText}
          allowClear
          size="large"
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: '100%' }} // Ensure it stretches inside the column
        />
      </Col>
      
      <Col xs={24} sm={{ flex: 'none' }}>
        <Button
          type="primary"
          size="large"
          onClick={() => handleSearch(searchText)}
          style={{ width: '100%' }}
        >
          Search
        </Button>
      </Col>
    </Row>
    <GenericCardList dataSource={dataSource} renderItem={renderItem} isLoading={isLoading} pagination={pagination}/>
  </>);
};

GenericSearchableList.propTypes = {
  dataSource: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
  pageSize: PropTypes.number,
  searchHint: PropTypes.string,
  onHandleSearch: PropTypes.func,
  isLoading: PropTypes.bool,
  pagination: PropTypes.object,
};
